<span class="kr-popin-amount"><span :style="{ color: merchant.header.amount.color }">{{ totalAmountLabel }}</span></span>